"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withBasedRouter = _interopRequireDefault(require("@devsta/with-based-router"));

var _basePath = _interopRequireDefault(require("../../../common/constants/basePath"));

var _BookmarkedPosts = _interopRequireDefault(require("../../../common/components/BookmarkedPosts"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function FeaturePostsComponent(_ref) {
  var history = _ref.history;
  return _react.default.createElement("div", {
    className: "featured-posts page"
  }, _react.default.createElement(_BookmarkedPosts.default, {
    history: history,
    isFeatured: true
  }));
}

var _default = (0, _withBasedRouter.default)(_basePath.default, FeaturePostsComponent);

exports.default = _default;